import { render, staticRenderFns } from "./ArticleTextSection.vue?vue&type=template&id=762a02ad&"
import script from "./ArticleTextSection.vue?vue&type=script&lang=coffee&"
export * from "./ArticleTextSection.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports